import common from './common.json';
import directories from './directories.json';
import directory from './directory.json';
import drawers from './drawers.json';
import header from './header.json';
import matching from './matching.json';
import sidebar from './sidebar.json';

export default { header, common, directory, matching, directories, sidebar, drawers };
